import RequestHandler from "./RequestHandler";

export const SESSION_STATUS = {
  LOADING: "loading",
  AUTHENTICATED: "authenticated",
  ANONYMOUS: "anonymous",
};

/** Login / üyeliksiz ödeme vb. — burada FirmAuth/Me atılmaz (cross-domain csrf gürültüsü + 401 spam). */
const PUBLIC_PATH_PREFIXES = [
  "/signin",
  "/signup",
  "/forget-password",
  "/pay-without-login",
  "/reset-password",
  "/new-password",
  "/pos-collection-result",
  "/paymentPage",
];

const isPublicPath = (pathname = "") => {
  const path = pathname.toLowerCase();
  return PUBLIC_PATH_PREFIXES.some(
    (prefix) => path === prefix || path.startsWith(`${prefix}/`)
  );
};

const hasSessionHint = () => {
  try {
    return !!(
      document.cookie.match(/fnk_sid|fnk_csrf/) ||
      sessionStorage.getItem("fnk_csrf_client") ||
      sessionStorage.getItem("fnk_rt_fallback")
    );
  } catch (e) {
    return false;
  }
};

export const bootstrapSession = async () => {
  RequestHandler.clearLegacyAuthStorage();

  if (typeof window !== "undefined" && isPublicPath(window.location.pathname)) {
    return { status: SESSION_STATUS.ANONYMOUS, profile: null };
  }

  if (!hasSessionHint()) {
    return { status: SESSION_STATUS.ANONYMOUS, profile: null };
  }

  try {
    const result = await RequestHandler.fetchMe();
    if (result?.success && result?.data) {
      RequestHandler.setProfile(result.data);
      // Soft-enrich logo if needed (non-blocking for auth)
      try {
        const tenantInfo = await RequestHandler.get(
          "/FirmAuth/GetActiveTenantInfo",
          undefined,
          { skipRefresh: true, skipAuthRedirect: true }
        );
        if (tenantInfo?.success && tenantInfo?.data?.logoPath) {
          RequestHandler.setProfile({
            ...RequestHandler.getProfileSnapshot(),
            tenantLogo: tenantInfo.data.logoPath,
          });
        }
      } catch (e) {
        // ignore logo enrich errors
      }
      return {
        status: SESSION_STATUS.AUTHENTICATED,
        profile: RequestHandler.getProfileSnapshot(),
      };
    }
  } catch (e) {
    // fall through
  }

  return { status: SESSION_STATUS.ANONYMOUS, profile: null };
};
